import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCollaborationsByResearchArea } from "../../redux/actions/action";
import { createSelector } from "reselect";
import Header from "../Header";
import Footer from "../Footer";


const initialCollaborationsState = {
  collaborations: [],
  loading: false,
  error: null,
};

const selectCollaborationsState = (state) => {
  return state.collaborationsState ?? initialCollaborationsState;
};

const selectEducationCollaborations = createSelector(
  [selectCollaborationsState],
  (collaborationsState) => collaborationsState.collaborations
);

const selectLoading = createSelector(
  [selectCollaborationsState],
  (collaborationsState) => collaborationsState.loading
);

const selectError = createSelector(
  [selectCollaborationsState],
  (collaborationsState) => collaborationsState.error



);

// ----- Component -----
const HealthCareCollaboration = () => {
  const dispatch = useDispatch();
  const collaborations = useSelector(selectEducationCollaborations) || [];
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;

  useEffect(() => {
    // fetch only HealthCare and reset to first page
    dispatch(fetchCollaborationsByResearchArea("HealthCare"));
    setCurrentPage(1);
  }, [dispatch]);

  // Safety: always work with an array
  const list = Array.isArray(collaborations) ? collaborations : [];

  // Pagination math
  const totalPages = Math.max(1, Math.ceil(list.length / recordsPerPage));
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = list.slice(indexOfFirst, indexOfLast);

  return (
    <div className="min-h-screen flex flex-col bg-gray overflow-x-hidden">
      <Header />

      <main className="flex-1">
        {/* Hero / Title */}
        <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-20 text-center">
          <img
            className="mx-auto w-full max-w-[640px] h-auto object-cover"
            alt="Collaborations"
            src="/Group 143726497.png"
          />
          <h2 className="mt-8 text-white font-bold text-29xl md:text-4xl">
            HealthCare Collaborators
          </h2>
        </section>

        {/* Loading / Error */}
        {loading && (
          <p className="text-center text-white mt-10">Loading...</p>
        )}
        {error && (
          <p className="text-center text-red-400 mt-10">Error: {error}</p>
        )}

        {/* Empty state */}
        {!loading && list.length === 0 && (
          <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 text-center">
          <h1 className="text-29xl md:text-10xl font-extrabold text-purple-700 drop-shadow-lg animate-pulse">
          🚀 We are coming soon
        </h1>
          </section>
        )}

        {/* Records */}
        
   <div className="flex flex-col items-center justify-center w-full px-4">
          {/* Reduced top margin */}
          <div className="space-y-4 text-cold-grey-white text-justify font-poppins text-xl max-w-4xl mx-auto">
            {/* Collaboration records go here */}

            {currentRecords.map((collab, index) => (
              <div
                key={collab.projectNo || index}
                className="p-4 border-2 border-blue rounded-lg shadow-md"
              >
                <div className="space-y-4"> {/* gap only between fields */}
                  <div>
                    <p className="text-white-500 font-bold m-0">Project Sponsor</p>
                    <p className="text-white m-0">{collab.organizationName || "Unknown Organization"}</p>
                  </div>

                  <div>
                    <p className="text-white-500 font-bold m-0">Project Title</p>
                    <p className="text-white m-0">{collab.projectName || "Unknown Project"}</p>
                  </div>

                  <div>
                    <p className="text-white-500 font-bold m-0">Description</p>
                    <p className="text-white m-0">{collab.projectDescription || "No description available."}</p>
                  </div>

                  <div className="flex gap-10">
                    <div>
                      <p className="text-white-500 font-bold m-0">Start Date:</p>
                      <p className="text-white m-0">
                        {collab.startDate ? new Date(collab.startDate).toLocaleDateString("en-GB") : "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-white-500 font-bold m-0">End Date:</p>
                      <p className="text-white m-0">
                        {collab.endDate ? new Date(collab.endDate).toLocaleDateString("en-GB") : "N/A"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="text-white-500 font-bold m-0">Team Size:</p>
                    <p className="text-white m-0">{collab.teamSize || "N/A"}</p>
                  </div>

                  <div>
                    <p className="text-white-500 font-bold m-0">Team Members</p>
                    <p className="text-white m-0">{collab.teamMembers || "N/A"}</p>
                  </div>
                </div>
                   <hr className="h-[2px] my-4 w-6/7 mx-auto bg-gradient-to-r from-transparent via-white to-transparent border-1" />
              </div>
            ))}
          </div>


          {/* Pagination Controls */}
          <div className="flex justify-center mt-8 space-x-4 mb-6">
            <div className="flex justify-center mt-8 space-x-4">
              <button
                className={`w-28 px-4 py-2 bg-white text-black rounded text-center font-medium ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <span className="text-white text-lg">Page {currentPage} of {totalPages}</span>

              <button
                className={`w-28 px-4 py-2 bg-white text-black rounded text-center font-medium ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>

          </div>
        </div>
      </main>

      {/* Footer pinned to bottom via flex layout */}
      <Footer />
    </div>
  );
};

export default HealthCareCollaboration;
